module.exports = __webpack_public_path__ + "img/HU.b9d87010.png";